import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { Calendar } from 'react-widgets';
import {
  Popover,
  OverlayTrigger,
  Glyphicon,
} from 'react-bootstrap';

const propTypes = exact({
  showTime: PropTypes.bool.isRequired,
  maxDate: PropTypes.object.isRequired,
  currentDate: PropTypes.object.isRequired,
  setDateAction: PropTypes.func.isRequired,

  view: PropTypes.string,
});

class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(selectedDate) {
    this.props.setDateAction(selectedDate);
    this.overlay.hide();
  }

  render() {
    const {
      showTime, maxDate, currentDate, view,
    } = this.props;

    const overlay = (
      <Popover id="popover-nav-calendar" style={{ width: '100%' }}>
        <Calendar
          time={showTime}
          onChange={this.handleOnChange}
          max={maxDate}
          value={currentDate}
          footer={false}
          view={view}
        />
      </Popover>
    );

    return (
      <div>
        <OverlayTrigger ref={(ref) => { this.overlay = ref; }} trigger="click" overlay={overlay} placement="right" rootClose>
          <Glyphicon
            glyph="calendar"
            style={{ cursor: 'pointer' }}
          />
        </OverlayTrigger>
      </div>
    );
  }
}

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = {
  view: 'month',
};

export default DatePicker;
